'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const SalesTrendChart = dynamic(() => import('./SalesTrendChart'), { ssr: false });
const ProductArrivalsChart = dynamic(() => import('./ProductArrivalsChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-5">
      <div className="lg:col-span-3 xl:col-span-3">
        <SalesTrendChart />
      </div>
      <div className="lg:col-span-2 xl:col-span-2">
        <ProductArrivalsChart />
      </div>
    </div>
  );
}